// extracted by mini-css-extract-plugin
module.exports = {"notification":"Notification_notification__xWji1","notification__toast":"Notification_notification__toast__1M-us","toast":"Notification_toast__1jOPj"};